"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageFrameServiceData = void 0;
const pfs_client_1 = require("@zillow/pfs-client");
const MARKUP_FORMAT = { format: 'markup' };
const JSONOBJECT_FORMAT = { format: 'jsonObject' };
const FALLBACK_RESPONSE = {
    bodyScripts: {},
    headTags: {},
    topnav: {},
    footer: {},
    reg: {},
};
// Data we are requesting from PFS
const pfsComponents = {
    footer: MARKUP_FORMAT,
    reg: { ...MARKUP_FORMAT, optional: true },
    topnav: MARKUP_FORMAT,
    metaContent: JSONOBJECT_FORMAT,
};
async function getPageFrameServiceData({ gaTrackingId, guid, headerVersion, region, requestId, sid, ssid, loginMemento, zuid, profiles, requestHeaders, userType, deviceType, pfsHost, includeZsg, deferDropdowns, includeComscore, includeFonts, includeGTM, deferScripts, staticMarkup, } = {}) {
    const { core, topnav, footer, reg, headTags, bodyScripts } = await (0, pfs_client_1.getPageFrame)({
        gaTrackingId,
        guid,
        headerVersion,
        region,
        requestId,
        headers: requestHeaders,
        loginMemento,
        sid,
        ssid,
        zuid,
        profiles,
        userType,
        deviceType,
        pfsHost,
        pfsComponents,
        includeZsg,
        deferDropdowns,
        useFallback: true,
        includeComscore,
        includeFonts,
        includeGTM,
        deferScripts,
        staticMarkup,
    }).catch(e => {
        // Log but don't fail the page
        // eslint-disable-next-line no-console
        console.warn(e);
        return FALLBACK_RESPONSE;
    });
    return {
        core,
        bodyScripts,
        headTags,
        topnav,
        footer,
        reg: reg || {},
    };
}
exports.getPageFrameServiceData = getPageFrameServiceData;
